import React from 'react';



const Bottom = (props) => (
	<div className="header_bottom">

	</div>
)

export default Bottom;



// WEBPACK FOOTER //
// ./src/Components/Header/Bottom/index.js